// frontend-website/src/telemetry/deviceDetector.js
// Device, browser, and OS detection for telemetry

/**
 * DeviceDetector - Detects device type, browser, and operating system
 */
export class DeviceDetector {
    constructor() {
        this.userAgent = navigator.userAgent;
        this.deviceInfo = this._detectAll();
    }

    /**
     * Get all device information
     */
    getDeviceInfo() {
        return {
            userAgent: this.userAgent,
            deviceType: this.deviceInfo.deviceType,
            browser: this.deviceInfo.browser,
            os: this.deviceInfo.os,
            ipAddress: null, // Will be set by backend from request
            country: null,   // Will be set by backend from IP
            city: null       // Will be set by backend from IP
        };
    }

    /**
     * Detect all device information
     * @private
     */
    _detectAll() {
        return {
            deviceType: this._detectDeviceType(),
            browser: this._detectBrowser(),
            os: this._detectOS()
        };
    }

    /**
     * Detect device type (mobile, tablet, desktop)
     * @private
     */
    _detectDeviceType() {
        const ua = this.userAgent;

        // Check for mobile
        if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
            return 'mobile';
        }

        // Check for tablet
        if (/iPad|Android(?!.*Mobile)/i.test(ua)) {
            return 'tablet';
        }

        // Default to desktop
        return 'desktop';
    }

    /**
     * Detect browser
     * @private
     */
    _detectBrowser() {
        const ua = this.userAgent;

        // Edge (Chromium-based)
        if (/Edg\//i.test(ua)) {
            return 'Edge';
        }

        // Chrome
        if (/Chrome\//i.test(ua) && !/Edg\//i.test(ua)) {
            return 'Chrome';
        }

        // Safari
        if (/Safari\//i.test(ua) && !/Chrome\//i.test(ua)) {
            return 'Safari';
        }

        // Firefox
        if (/Firefox\//i.test(ua)) {
            return 'Firefox';
        }

        // Internet Explorer
        if (/MSIE|Trident\//i.test(ua)) {
            return 'Internet Explorer';
        }

        // Opera
        if (/Opera|OPR\//i.test(ua)) {
            return 'Opera';
        }

        return 'Unknown';
    }

    /**
     * Detect operating system
     * @private
     */
    _detectOS() {
        const ua = this.userAgent;

        // Windows
        if (/Windows NT/i.test(ua)) {
            if (/Windows NT 10/i.test(ua)) return 'Windows 10/11';
            if (/Windows NT 6.3/i.test(ua)) return 'Windows 8.1';
            if (/Windows NT 6.2/i.test(ua)) return 'Windows 8';
            if (/Windows NT 6.1/i.test(ua)) return 'Windows 7';
            return 'Windows';
        }

        // macOS
        if (/Macintosh|Mac OS X/i.test(ua)) {
            return 'macOS';
        }

        // iOS
        if (/iPhone|iPad|iPod/i.test(ua)) {
            return 'iOS';
        }

        // Android
        if (/Android/i.test(ua)) {
            return 'Android';
        }

        // Linux
        if (/Linux/i.test(ua)) {
            return 'Linux';
        }

        // Chrome OS
        if (/CrOS/i.test(ua)) {
            return 'Chrome OS';
        }

        return 'Unknown';
    }
}
